import { useApp } from "../../context/App";
import { useEffect, useState } from 'react';
import FlatList from 'flatlist-react';
import { Banner } from "../../components/sections/Banner";
import { TitlePage } from "../../components/ui/TitlePage";
import { api, urls } from '../../services/api';
import { IVideo } from '../../types/video';

export function ListVideosScreen() {

	const { mobile } = useApp()
	const [videos, setVideos] = useState<IVideo[]>([])

	useEffect(() => {
		(async () => {

			const response = await api.get(urls.VideosObject)

			//console.log('response.data:', response.data['videos'])

			setVideos(response.data['videos'])

		})()
	}, [])

	//console.log( 'videos', videos )

	return (
		<div className="flex flex-col w-full min-h-screen items-center justify-start bg-white dark:bg-surface-dark transition-colors">
			<TitlePage title="VÍDEOS" />

			<div className="w-11/12 lg:w-3/5 mt-8 lg:mt-8 mb-16">
				<FlatList
					list={videos.slice(0, 1)}
					renderItem={(item) => (
						<div key={item.videoId || item.ytId} className="w-full mb-12 lg:mb-16">
							<div className="w-full aspect-video overflow-hidden rounded-2xl lg:rounded-xl shadow-md dark:shadow-premium-dark border border-transparent dark:border-border-dark">
								<iframe title={item.title} className="w-full h-full" src={`https://www.youtube.com/embed/${item.ytId}`} />
							</div>
							<a
								href={`https://www.youtube.com/watch?v=${item.ytId}`}
								target="_blank"
								rel="noreferrer"
								className="no-underline group"
							>
								<div className="w-full mt-4 lg:mt-5 mb-2 font-bold text-lg lg:text-xl text-gray-900 dark:text-gray-100 group-hover:text-primary dark:group-hover:text-primary-light transition-colors text-center">
									{item.title}
								</div>
							</a>
						</div>
					)}
				/>

				<div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
					<FlatList
						list={videos.slice(1, videos.length)}
						renderItem={(item) => (
							<div key={item.videoId || item.ytId} className="w-full flex flex-col group">
								<a
									href={`https://www.youtube.com/watch?v=${item.ytId}`}
									target="_blank"
									rel="noreferrer"
									className="no-underline flex flex-col items-center"
								>
									<div
										className="w-full aspect-video overflow-hidden rounded-xl lg:rounded-lg shadow-sm group-hover:shadow-md dark:shadow-none dark:border dark:border-border-dark bg-no-repeat bg-center bg-cover transition-all group-hover:-translate-y-1"
										style={{
											backgroundImage: `url(//img.youtube.com/vi/${item.ytId}/0.jpg)`
										}}
									></div>
									<div className="w-full mt-4 mb-2 font-semibold text-base lg:text-sm text-gray-900 dark:text-gray-100 group-hover:text-primary dark:group-hover:text-primary-light transition-colors text-center line-clamp-2">
										{item.title}
									</div>
								</a>
							</div>
						)}
					/>
				</div>
			</div>

			<Banner mobile={mobile} />
		</div>
	);
}